import { injectable } from "inversify";
import ScheduleEntity from "../../entities/ScheduleEntity";
import { compareSchedules } from "../../../presentation/utils/ScheduleComparator";

@injectable()
export default class SortSchedulesUseCase {
    /**
     * Sorts an array of schedules by:
     * 1. Day of week (Lunes -> Domingo)
     * 2. Opening time (ascending)
     *
     * @param schedules - Array of ScheduleEntity to sort
     * @returns A new sorted array (does not mutate original)
     */
    public execute(schedules: ScheduleEntity[]): ScheduleEntity[] {
        // Create a copy to avoid mutating the original array
        return [...schedules].sort(compareSchedules);
    }
}

export const SortSchedulesUseCaseName = "SortSchedulesUseCase";
